module.exports = __webpack_public_path__ + "static/media/2.Starters.2a5f1078.jpg";